(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3752],{

/***/ 97736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60558);
/* harmony import */ var _components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78182);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35005);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40607);











const FeaturedPartnerWebinars = ({ title  })=>{
    const { 0: delegateWebinars , 1: setDelegateWebinars  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: kcExpertWebinars , 1: setKcExpertWebinars  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: tabValue , 1: setTabValue  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(`${"https://cms-staging.studies-overseas.com"}/partner-webinars?webinarType=webinar_by_university_delegate&_sort=startDate:ASC&_start=0&_limit=3`, "GET", {}, "", false).then((res)=>{
            setDelegateWebinars(res);
        });
        (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(`${"https://cms-staging.studies-overseas.com"}/partner-webinars?webinarType=webinar_by_kc_expert&_sort=startDate:ASC&_start=0&_limit=3`, "GET", {}, "", false).then((res)=>{
            setKcExpertWebinars(res);
        });
    }, []);
    const settings = {
        dotsClass: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sliderDots),
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    };
    const respectiveWebinars = tabValue === 1 ? delegateWebinars : kcExpertWebinars;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            id: "featured-partnerwebinars",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().theEventweek),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainTitle),
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: `${(_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().eventTabs)} nav nav-tabs`,
                        style: {
                            marginBottom: "50px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: ()=>setTabValue(1),
                                    type: "button",
                                    className: `nav-link ${tabValue === 1 ? "active" : ""}`,
                                    children: "Webinars by University"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: ()=>setTabValue(2),
                                    type: "button",
                                    className: `nav-link ${tabValue === 2 ? "active" : ""}`,
                                    children: "Webinars by KC"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "d-none d-sm-block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "the-eventweek",
                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().theEventweek),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: respectiveWebinars?.length > 0 ? respectiveWebinars.map((event)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    xs: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().cardCust),
                                        style: {
                                            height: "350px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Img */ .Z.Img, {
                                                variant: "top",
                                                src: event.imageUrl,
                                                alt: event.imageAltTag
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Body */ .Z.Body, {
                                                className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().cardBody),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Text */ .Z.Text, {
                                                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().textDate),
                                                        children: [
                                                            event.date,
                                                            " \xb7 ",
                                                            event.time
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Title */ .Z.Title, {
                                                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subTitle),
                                                        children: event.name
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                        size: "lg",
                                                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().btEduExpo),
                                                        onClick: ()=>router.push(event.registerUrl),
                                                        children: "Register Now"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, event.id);
                            }) : "No Webinars"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "respectiveWebinars",
                    className: "d-block d-sm-none",
                    children: respectiveWebinars.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().theEventweek),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            ...settings,
                            className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().slider),
                            children: respectiveWebinars.map((event)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            xs: 12,
                                            md: 4,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().cardCust),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Img */ .Z.Img, {
                                                        variant: "top",
                                                        src: event.imageUrl,
                                                        alt: event.imageAltTag
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Body */ .Z.Body, {
                                                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().cardBody),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Text */ .Z.Text, {
                                                                className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().textDate),
                                                                children: [
                                                                    event.date,
                                                                    " \xb7 ",
                                                                    event.time
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Title */ .Z.Title, {
                                                                className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subTitle),
                                                                children: event.name
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                size: "lg",
                                                                className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().btEduExpo),
                                                                onClick: ()=>router.push(event.registerUrl),
                                                                children: "Register Now"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }, event.id);
                            })
                        })
                    }) : "No Webinars"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-center mt-3 mb-5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: `${tabValue === 1 ? "/partners/webinar-by-university-delegates" : "/partners/webinar-by-kc-admission-experts"}`,
                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_5___default().viewMore),
                        children: "View More"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeaturedPartnerWebinars);


/***/ }),

/***/ 55689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42547);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34051);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10682);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59830);
/* harmony import */ var _LazyMedia__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37462);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70710);













const VideoTestimonials = (props)=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const limitedTestimonials = props.testimonialVideos?.sort((firstVideoTestimonial, secondVideoTestimonial)=>secondVideoTestimonial.id - firstVideoTestimonial.id)?.slice(0, 15);
    const videosCount = props.testimonialVideos?.length || 0;
    const videosSlidersettings = {
        infinite: videosCount > 3,
        arrows: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        rows: 1,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    infinite: videosCount > 2,
                    autoplay: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dotsClass: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderDots),
                    infinite: videosCount > 1,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.mobileAutoplaySpeed */ .Y$.mobileAutoplaySpeed
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievements),
        style: {
            backgroundColor: props.sectionBgColor || "#ffffff",
            ...props?.parentContainerStyles ?? {}
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerDiv),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().heading),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().description),
                                children: props.subTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderContainer),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                ...videosSlidersettings,
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().slider),
                                ref: sliderRef,
                                children: limitedTestimonials?.length > 0 && limitedTestimonials?.map((content, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievementsDiv),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                    width: "33",
                                                    height: "22",
                                                    viewBox: "0 0 33 22",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                            fill: "#226CF5"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                            fill: "#226CF5"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().videoDiv),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__.LazyLoadComponent, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                        iframeClassName: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().studVideo),
                                                        src: content.videoLink,
                                                        title: "YouTube video player",
                                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        children: content.name
                                                    }),
                                                    content?.designation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.designation
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.university
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            }),
                            props.testimonialVideos?.length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().arrowsClass),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickPrev(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/left-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "left-arrow"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickNext(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/right-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "right-arrow"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoTestimonials);


/***/ }),

/***/ 537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82908);
/* harmony import */ var _styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78182);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45992);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40607);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59830);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70710);













const Testimonial = ({ title , bgColor , slug , data  })=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: testimonialData , 1: setTestimonialData  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const { 0: centerSlide , 1: setCenterSlide  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const settings = {
        dotsClass: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().sliderDots),
        dots: false,
        infinite: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        initialSlide: 1,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.mobileSpeed */ .Y$.mobileSpeed,
                    arrows: false,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 200
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    dots: false
                }
            }
        ]
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        data ? setTestimonialData(data) : (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(`${"https://cms-staging.studies-overseas.com"}/${slug}`, "GET", {}, "", false).then((res)=>setTestimonialData(res));
    }, []);
    return testimonialData?.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        id: "studenttestimonial",
        className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().studentTestSlider),
        style: {
            backgroundColor: bgColor
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "mb-5 text-center",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "studentmm",
                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().student),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ...settings,
                                    ref: sliderRef,
                                    className: `${(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().slider)}`,
                                    children: testimonialData.map((slide, ind)=>{
                                        return ind < 15 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                className: `${(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().stuTestCard)}`,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Body */ .Z.Body, {
                                                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cardBody),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                            width: "33",
                                                            height: "22",
                                                            viewBox: "0 0 33 22",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                                    fill: "#226CF5"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                                    fill: "#226CF5"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "my-4",
                                                            children: slide?.testimonial?.message
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                            className: "mb-0",
                                                            children: slide?.testimonial?.name
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().addre),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: slide?.testimonial?.details
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: slide?.testimonial?.subDetails
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }, ind);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrowsClass),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btcircle),
                                            onClick: ()=>sliderRef?.current?.slickPrev(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/new-images/left-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "left-arrow"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btcircle),
                                            onClick: ()=>sliderRef?.current?.slickNext(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/new-images/right-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "right-arrow"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Testimonial);


/***/ }),

/***/ 97761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73017);
/* harmony import */ var _styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40607);









const TopTieUpsOfKC = ()=>{
    const { 0: topTieUps , 1: setTopTieUps  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(`${"https://cms-staging.studies-overseas.com"}/top-university-tie-ups`, "GET", {}, "", false).then((res)=>setTopTieUps(res));
    }, []);
    return topTieUps ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "uni-tie-upmain",
        className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().uniTieUp),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "unitieuptxt",
                        className: `text-center ${(_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading)}`,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().uniDiv),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: topTieUps?.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: topTieUps?.description
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    id: "unitieupLogo",
                    className: "text-center",
                    children: topTieUps?.images?.length > 0 && topTieUps.images.map((images, index)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            xl: 3,
                            md: 3,
                            xs: 6,
                            className: `${(_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().cols)} ${index > 3 ? (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().borderl0) : ""}`,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().unidiv),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    src: images?.imageUrl,
                                    alt: images?.imageAltTag,
                                    width: 174,
                                    height: 75
                                })
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-center mt-3",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "/universities",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            id: "moreUniId",
                            className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().viewMore),
                            children: "More Universities"
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["default"] = (TopTieUpsOfKC);


/***/ }),

/***/ 60558:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"abttopContent":"UpcomingEvents_abttopContent__8_Cqm","btEduExpoAlign":"UpcomingEvents_btEduExpoAlign__r4jRr","btEduExpo":"UpcomingEvents_btEduExpo__uSk_h","abttopContentdesk":"UpcomingEvents_abttopContentdesk__4DRX_","centerContent":"UpcomingEvents_centerContent__dvBF5","edtech":"UpcomingEvents_edtech__fjg7n","bgColor":"UpcomingEvents_bgColor__xgRwv","breadcrum":"UpcomingEvents_breadcrum__jbHmP","enquirebtn":"UpcomingEvents_enquirebtn__zjJkV","heading":"UpcomingEvents_heading__ZnCl8","buttongp":"UpcomingEvents_buttongp__3E1Bq","kcbtn":"UpcomingEvents_kcbtn__LHQpf","centered":"UpcomingEvents_centered__iAPwJ","eduExpoBox":"UpcomingEvents_eduExpoBox__zy4ht","breadcrumb-item":"UpcomingEvents_breadcrumb-item__v5_PK","active":"UpcomingEvents_active__0fxRu","hideimg":"UpcomingEvents_hideimg__Sc_dI","rowPadding":"UpcomingEvents_rowPadding__y4jPW","viewMoreContainer":"UpcomingEvents_viewMoreContainer__q4cNo","viewMore":"UpcomingEvents_viewMore__lOSeT","learnText":"UpcomingEvents_learnText__Vr50O","iconSetting":"UpcomingEvents_iconSetting__pC0En","theEventweek":"UpcomingEvents_theEventweek__vmHHo","textDate":"UpcomingEvents_textDate__eoPkZ","subTitle":"UpcomingEvents_subTitle__GNXd_","descripEvent":"UpcomingEvents_descripEvent__vu5nx","smallText":"UpcomingEvents_smallText__iJQTM","cardCust":"UpcomingEvents_cardCust__nyKHs","cardBody":"UpcomingEvents_cardBody__uMJY1","card-img":"UpcomingEvents_card-img__LTmtQ","card-img-bottom":"UpcomingEvents_card-img-bottom__to1l5","card-img-top":"UpcomingEvents_card-img-top__DLVhH","eventTabs":"UpcomingEvents_eventTabs__Ede2L","inputBox":"UpcomingEvents_inputBox__dRGBn","inputBtn":"UpcomingEvents_inputBtn__my_x0","filtersDrop":"UpcomingEvents_filtersDrop__XkKhQ","filtercheck":"UpcomingEvents_filtercheck__BBnDo","selectdiv":"UpcomingEvents_selectdiv__Pf5jW","Selectfilt":"UpcomingEvents_Selectfilt__oWxuW","activeSelect":"UpcomingEvents_activeSelect__ZRVvC","filterSelect":"UpcomingEvents_filterSelect__1PKpc","mobilemenu":"UpcomingEvents_mobilemenu__xAQYx","btn":"UpcomingEvents_btn___nusr","menu":"UpcomingEvents_menu__asLuI","modal-footer":"UpcomingEvents_modal-footer__oiTSK","filtCat":"UpcomingEvents_filtCat__o6vJI","footerSpace":"UpcomingEvents_footerSpace__6Mypb","btnsecondary":"UpcomingEvents_btnsecondary__NxzAQ","btnprimary":"UpcomingEvents_btnprimary__Jp15R","contain":"UpcomingEvents_contain__krwNI","catfilter":"UpcomingEvents_catfilter__Ik3Va","catSelected":"UpcomingEvents_catSelected__VeDzY","optfilter":"UpcomingEvents_optfilter__hOEqg","optselfilter":"UpcomingEvents_optselfilter__YAX2p","sliderDots":"UpcomingEvents_sliderDots__XhxBQ","mainTitle":"UpcomingEvents_mainTitle__Zal4Q","titleClass":"UpcomingEvents_titleClass__BIkV1","clearFilter":"UpcomingEvents_clearFilter__PVLcj"};

/***/ }),

/***/ 73017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uniTieUp":"Unitieup_uniTieUp__tb7S6","cols":"Unitieup_cols__vvM4K","borderl0":"Unitieup_borderl0__x9LQV","border0":"Unitieup_border0__pocJi","viewMore":"Unitieup_viewMore__jrZKp","heading":"Unitieup_heading__tu7PU"};

/***/ }),

/***/ 82908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentServicesPage":"studentservices_studentServicesPage__jDBb9","studentServicesCurve":"studentservices_studentServicesCurve__V6eKt","contentDiv":"studentservices_contentDiv__wEbZf","enquirebtn":"studentservices_enquirebtn__ld5mL","servContent":"studentservices_servContent__PL5SN","WhyKc":"studentservices_WhyKc__sZxHm","viewMore":"studentservices_viewMore__bN0nA","img":"studentservices_img__H06y5","studentServicesWebinarEvent":"studentservices_studentServicesWebinarEvent__YR1_a","studentHelpMainDiv":"studentservices_studentHelpMainDiv__1GWsb","studentHelp":"studentservices_studentHelp__1fO7O","alignTop":"studentservices_alignTop__iMtE_","subAnchor":"studentservices_subAnchor__jRKHU","knowMore":"studentservices_knowMore__Y1q7q","linksDiv":"studentservices_linksDiv__KAP9F","studentServicesKcUpdates":"studentservices_studentServicesKcUpdates__LWcWL","StudentBlogs":"studentservices_StudentBlogs__TKFes","studentFooter":"studentservices_studentFooter__C7T7a","session":"studentservices_session__I15Qa","student":"studentservices_student__R_JgR","middelStuTest":"studentservices_middelStuTest__JJpvH","stuTestCard":"studentservices_stuTestCard__s_G5N","cardBody":"studentservices_cardBody__fAO4I","addre":"studentservices_addre__cGp__","studentTestSlider":"studentservices_studentTestSlider__bff6C","sevenBG":"studentservices_sevenBG__ovks8","sliderDots":"studentservices_sliderDots__PrfDo","slick-slide":"studentservices_slick-slide__Zwpji","slick-center":"studentservices_slick-center__42LQ5","arrowsClass":"studentservices_arrowsClass__pblWv","btcircle":"studentservices_btcircle__uDqgR","arrowsClasses":"studentservices_arrowsClasses__SQl3Q"};

/***/ })

}]);